



















































import {Component, Mixins, Vue} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {Mutations} from '@/ts/store/Constants';
import TargetedRecipientList from '@/components/Admin/Lists/TargetedRecipientList.vue';

@Component({
  components: {
    TargetedRecipientList,
  },

  computed: {
    ...mapGetters({
      getTargetedRecipients: 'Recipients/getAssignedProjectWithUnit',
    }),
  },
})
export default class TargetedRecipientListModal extends Vue {

  public cancel(event: any) {
    if (event === null || event.target.className === 'hoc-overlay') {
      this.$store.commit(Mutations.SET_TARGETED_RECIPIENTS_MODAL_VISIBILITY, false);
      this.$store.commit(Mutations.SET_TARGETED_RECIPIENTS, null);
    }
  }

  public destroyed() {
    this.cancel(null);
  }

  public submitCancel() {
    this.cancel(null);
  }
}
